import tw, { styled } from "twin.macro";

const PanelHeader = styled.h6(({ disabled }: { disabled?: boolean }) => [
    tw`text-lg mb-6 [font-weight:800] relative flex items-stretch before:(self-stretch my-[0.35rem] [width:0.30rem] bg-primary-500 mr-2)`,
    disabled && tw`mb-0 text-gray-400 before:bg-primary-300`,
]);

export default PanelHeader;
